"use strict";
import {find, on} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-input-reset', resetButton => {
        on('click', (evt) => {
            evt.preventDefault();
            find(resetButton.getAttribute('data-reset-target')).value = '';
        }, resetButton);
    });
}